<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">مشاهده سفارش {{ id }}</h5>
        <div style="flex: 1"></div>
        <div
          v-if="hasPermission('change_mini_order_status')"
          class="d-flex align-center"
        >
          <!-- <button
            :disabled="disabled"
            class="btn btn-success ml-2"
            @click="acceptOrder()"
          >
            تایید سفارش
          </button>
          <button
            :disabled="disabled"
            class="btn btn-danger ml-2"
            @click="rejectOrder()"
          >
            رد سفارش
          </button> -->
        </div>
        <button class="btn btn-primary ml-2" @click="print">
          <i class="fa fa-print"></i>
        </button>
        <Back url="/admin/shop/orders" />
      </div>
      <!-- <img class="logo" :src="$options.configProvider.get('logo')" />   -->
      <div class="card-body">
        <div v-if="loaderPrint" class="d-flex w-100 justify-content-center">
          <Loading />
        </div>
        <div id="print" v-if="item">
          <div class="d-flex justify-content-between">  
            <div class="flex-grow-1">  
              <div class="d-flex flex-column">  
                <div class="rounded text-dark my-1">  
                  وضعیت سفارش:  
                  <span  
                    v-if="item.confirmed == 'confirmed'"  
                    class="font-weight-bold text-success pr-1"  
                  >  
                    تایید شده  
                  </span>  
                  <span  
                    v-else-if="item.confirmed == 'rejected'"  
                    class="font-weight-bold text-danger pr-1"  
                  >  
                    رد شده  
                  </span>  
                  <span  
                    v-else-if="item.confirmed == 'not_checked'"  
                    class="font-weight-bold text-info pr-1"  
                  >  
                    جدید  
                  </span>  
                </div>  
                <div class="row-1">  
                  <div class="row-1-item">  
                    <div v-if="item.customer && (item.customer.first_name || item.customer.last_name)">  
                      نام و نام خانوادگی:  
                      <span v-if="item.customer.first_name">{{  
                        item.customer.first_name    
                      }}</span>  
                      <span v-else-if="item.customer.last_name">{{  
                        item.customer.last_name
                      }}</span>  
                      <span v-else>{{  
                        item.customer.first_name + item.customer.last_name
                      }}</span>  
                    </div>  
                    <div v-if="item.customer">  
                      مشتری:  
                      <span>{{  
                        item.customer.mobile  
                      }}</span>  
                    </div>  
                    <div>  
                      تاریخ: <span>{{ item.created_at | persianDate }}</span>  
                    </div>  
                    <div>  
                      شماره فاکتور: <span class="font-weight-bold">{{ item.id }}</span>  
                    </div>  
                  </div>  
                </div>  
                <div class="row-1-item">  
                  <div>  
                    صندوق دار:  
                    <span>{{  
                      item.creatorable ? item.creatorable.name : ""  
                    }}</span>  
                  </div>  
                </div>  
                <div class="row-1-item" v-if="item.is_digify_cashier">  
                  <div class="text-info">  
                    سفارش از دیجی پی میباشد
                  </div>  
                </div>  
                <div class="row-1-item" v-else-if="item.is_snappay_cashier">  
                  <div class="text-info">  
                    سفارش از اسنپ پی میباشد
                  </div>  
                </div>  
              </div>  
            </div>  
            <div class="me-3">  
              <img class="logo" :src="$options.configProvider.get('logo')" />  
            </div>  
          </div>  
              <!-- <div class="row-1-item pl-5 barcode-print">
                <barcode :height="80" :value="item.id" :displayValue="true">
                </barcode>
              </div> -->
            <div v-if="sellItems.length" class="row-2">
              <div class="row-2-header black-bg">مشخصات کالا</div>
              <div class="row-2-table">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th>کد</th>
                      <th>عنوان</th>
                      <th>تعداد</th>
                      <th>قیمت</th>
                      <th>تخفیف</th>
                      <th>جمع کل</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ShopShowItem
                      v-for="miniOrderItem in sellItems"
                      :item="miniOrderItem"
                      :miniOrder="miniOrder"
                      :key="miniOrderItem.id"
                    />
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="refundItems.length" class="row-2">
              <div class="row-2-header black-bg">مشخصات کالا(مرجوعی)</div>
              <div class="row-2-table">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th>کد</th>
                      <th>عنوان</th>
                      <th>تعداد</th>
                      <th>قیمت</th>
                      <th>تخفیف</th>
                      <th>افزایش کیف پول</th>
                      <th>جمع کل</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ShopShowItem
                      v-for="miniOrderItem in refundItems"
                      :item="miniOrderItem"
                      :key="miniOrderItem.id"
                    />
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row-3">
              <table class="table table-bordered">
                <tr>
                  <td>تعداد کالا</td>
                  <td>{{ miniOrderItemsCount }}</td>
                </tr>
                <tr>  
                  <td>مجموع قیمت کالا ({{ getPriceName() }})</td>  
                  <td>  
                    {{ getPrice(Number(item.total) + Number(miniOrder.sum_refund) + 
                    sellItems.reduce((total, variety) => total + variety.discount_amount * variety.quantity, 0)) | price }}  
                    <span v-if="(Number(item.total) + Number(miniOrder.sum_refund)) < 0">-</span>  
                  </td>  
                </tr>  
                <tr v-if="miniOrder.sum_refund > 0">
                  <td>جمع مرجوعی ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.sum_refund) | price }}</td>
                </tr>
                <tr v-if="sellItems.length">
                  <td>تخفیف ({{ getPriceName() }})</td>
                  <td>{{ ( miniOrder.discount_amount > 0 ? getPrice(sellItems.reduce((total, variety) => total + variety.discount_amount * variety.quantity, 0) + miniOrder.discount_amount) : getPrice(sellItems.reduce((total, variety) => total + variety.discount_amount * variety.quantity, 0)) ) | price }}</td>
                </tr>
                <tr v-if="miniOrder.cash_amount > 0">
                  <td>نقدی ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.cash_amount) | price }}</td>
                </tr>
                <tr v-if="miniOrder.cardByCard_amount > 0">
                  <td>کارت به کارت ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.cardByCard_amount) | price }}</td>
                </tr>
                <tr v-if="miniOrder.from_wallet_amount > 0">
                  <td>از کیف پول ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.from_wallet_amount) | price }}</td>
                </tr>
                <tr v-if="refundItems.some(item => item.charging_wallet_amount > 0)">
                  <td>مجموع افزایش کیف پول ({{ getPriceName() }})</td>
                  <td>{{  getPrice(refundItems.reduce((sum, item) => {
                    return sum + (item.charging_wallet_amount * item.quantity);
                  }, 0) + miniOrder.from_wallet_amount) | price }}</td>
                </tr>
                <tr v-if="miniOrder.digipay_cashier_amount > 0">
                  <td>مبلغ دیجی پی ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.digipay_cashier_amount) | price }}</td>
                </tr>
                <tr v-if="miniOrder.snappay_cashier_amount > 0">
                  <td>مبلغ اسنپ پی ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.snappay_cashier_amount) | price }}</td>
                </tr>
                <tr>
                  <td>از پوز ({{ getPriceName() }})</td>
                  <td>{{ getPrice(miniOrder.pos_amount) | price }}</td>
                </tr>
              </table>
            </div>
            <div class="row-4">
              <div class="row-4-item">
                <div>{{ settings.shop_name }}</div>
                <div>{{ store.mobile }}</div>
              </div>
              <div>{{ store.address ? store.address : settings.shop_address }}</div>
            </div>
        </div>
        <div v-else class="d-flex w-100 justify-content-center">
          <Loading />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from "@@/core/components/shared/Loading/Loading";
import configProvider from "@@/core/configProvider";
import Back from "@@/core/components/shared/Back/Back";
import { Printd } from "printd";
import styles from "@@/core/pages/physicalShop/getStyles";
import ShopShowItem from "@@/core/pages/physicalShop/components/ShopShowItem";

export default {
  name: "ShopCreate",
  configProvider,
  components: { ShopShowItem, Loading, Back },
  data() {
    return {
      item: null,
      miniOrder: [],
      store: [],
      id: this.$route.params.id,
      settings: {},
      disabled: false,
      instagram: "pashik_org pashik_vip\npashik_shoes_children",
      loaderPrint: false,
    };
  },
  computed: {
    refundItems() {
      return this.item.mini_order_items.filter((i) => i.type === "refund");
    },
    sellItems() {
      return this.item.mini_order_items.filter((i) => i.type === "sell");
    },
    miniOrderItemsCount() {
      if (!this.item) {
        return 0;
      }

      return this.item.mini_order_items.reduce((a, b) => a + b.quantity, 0);
    },
  },
  mounted() {
    this.loadItem();
    this.acceptOrder();
  },
  methods: {
    getPriceName() {
      return configProvider.get("physicalShop.printPrice") === "rial"
        ? "ریال"
        : "تومان";
    },
    getPrice(price) {
      return configProvider.get("physicalShop.printPrice") === "rial"
        ? price * 10
        : price;
    },
    async loadItem() {
      try {
        const response = await this.$axios.get("admin/mini_orders/" + this.id, {
          params: {
            widgets: JSON.stringify(["settings"]),
          },
        });
        this.miniOrder = response.data.data.mini_order;
        const miniOrder = response.data.data.mini_order;
        miniOrder.mini_order_items.forEach((miniOrderItem) => {
          miniOrderItem.extra = JSON.parse(miniOrderItem.extra);
        });
        const settings = {};
        response.data.data.widgets.settings.forEach((s) => {
          settings[s.name] = s.value;
        });
        this.settings = settings;
        this.item = miniOrder;
        this.store = response.data.data.store;
        if (this.$route.query.print) {
          this.loaderPrint = true;
          this.$nextTick(() => {
            setTimeout(() => {
              this.loaderPrint = false;
              this.print();
              this.$router.push(`/admin/shop/create`);
            }, 1000);
          });
        }
      } catch (e) {
        this.$root.notify(e);
      }
    },
    print() {
      const d = new Printd();
      let _styles;
      const _barcodePrint = `
        #print {
          position: relative;
        }
        .barcode-print {
          position: absolute;
          top: 0;
          left:0;
        }
        .row-1 {
          margin-bottom: 2rem !important;
        }
      `;
      if (configProvider.get("print_font")) {
        _styles =
          styles +
          "@font-face{font-family:'yekan-bakh';src:url(" +
          configProvider.get("print_font") +
          ") format('woff');font-weight:normal;font-style:normal;}";
      } else {
        _styles = styles;
      }
      d.print(document.getElementById("print"), [_styles, _barcodePrint]);
    },
    // تایید سفارش توسط چکر
    async acceptOrder() {
      try {
        this.disabled = true;
        const response = await this.$axios.post(
          `/admin/mini_orders/${this.id}/confirm`,
          { confirmed: "confirmed" }
        );
        // this.$root.notify(response.data.message, "success");
        // this.$router.push("/admin/shop/orders")
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    // رد سفارش توسط چِکر
    async rejectOrder() {
      try {
        this.disabled = true;
        const response = await this.$axios.post(
          `/admin/mini_orders/${this.id}/confirm`,
          { confirmed: "rejected" }
        );
        this.$root.notify(response.data.message, "success");
        this.$router.push("/admin/shop/orders");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style scoped>
.whitePre {
  white-space: pre-wrap;
}
.card.little .card-header {
  font-weight: bold;
}
</style>
<style>
.logo {
  width: 200px;
  height: 100px;
  display: block;
  margin: auto;
}

.black-bg {
  background: #363636;
  color: white;
}

.row-1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* display: flex;
  align-items: stretch;
  justify-content: space-between; */
}

.row-2-header {
  padding: 4px 0;
  text-align: center;
  font-weight: bold;
}

.row-4-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
#print {
  position: relative;
}
.barcode-print {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
